module.exports = __webpack_public_path__ + "img/portfolio-05 - Copy.5dee8713.jpg";